var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavoriteOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#70A53C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    className: "st0",
    d: "M12,17.8899994l6.1800003,3.7299995l-1.6399994-7.0299997L22,9.8599997L14.8099995,9.25 L12,2.6199999L9.1899996,9.25L2.0000005,9.8599997l5.46,4.7299995l-1.6399999,7.0299997L12,17.8899994z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoriteOutline);
export default __webpack_public_path__ + "static/media/Icon_FavoriteOutline.5b76fd49524febe81c5b672988f9914d.svg";
export { ForwardRef as ReactComponent };